import { JsonModel, Model } from './model'

export class SupplierRecovery extends Model {
    assignedUser: number
    balance: number
    supplierId: number
    supplierName: string
    supplierPhone: string
    hasRecentlyPaid: boolean

    constructor(json: JsonSupplierRecovery) {
        super(json)

        this.assignedUser = json.assignedUser
        this.balance = json.balance
        this.supplierId = json.supplierId
        this.supplierName = json.supplierName
        this.supplierPhone = json.supplierPhone
        this.hasRecentlyPaid = json.hasRecentlyPaid ?? false
    }
}

export interface JsonSupplierRecovery extends JsonModel {
    assignedUser: number
    balance: number
    supplierId: number
    supplierName: string
    supplierPhone: string
    hasRecentlyPaid?: boolean
}
